app.headerController = app.headerController || {};
app.headerController.defaultAction = {
   
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        this.menuMobile();
        this.infoSlide();
        this.menuLvl2();
    },

    menuLvl2 : function () {
        var menu = $('header nav');
        var submenu = menu.find('.sub-menu > .menu-item-has-children a > .arrow-down');

        submenu.on('click', function (event) {
            $(this).parent().find('> a').toggleClass('active');
            event.preventDefault();
            console.log($(this).parent());

        });
    },

    menuMobile : function() {
        var self = this;

        var button = $('header .icon-menu');
        var icon = button.find('.hamburger-box');
        var text = button.find('span');
        var menu = $('header nav');
        var submenu = menu.find('.menu-item-has-children > a');

        button.on('click', function () {
            if (button.hasClass('active')) {
                button.removeClass('active');
                icon.removeClass('is-active');
                menu.removeClass('active');
                self.mediaQuery(menu);
                text.text('MENU');
            } else {
                button.addClass('active');
                icon.addClass('is-active');
                menu.addClass('active');
                self.mediaQuery(menu);
                text.text('FERMER');
            }
        });

        submenu.on('click', function (e) {
            if (window.matchMedia("(max-width: 1025px)").matches){
                e.preventDefault();
            }
            $(this).toggleClass('active');
            $(this).next().toggleClass('active');
        });

        self.mediaQuery(menu);

        $( window ).resize(function() {
            self.mediaQuery(menu);
        });
    },

    infoSlide : function () {
        var block = $('.block-info');
        var button = block.find('.info-button');

        if ($( document ).find('.home-content').length > 0){
            block.addClass('active');
        }

        button.on('click', function() {
            if (block.hasClass('active')) {
                block.removeClass('active');
            } else {
                block.addClass('active');
            }
        });

    },

    mediaQuery : function (menu) {
        var height = menu.height();

        if ( (window.matchMedia("(max-width: 1025px)").matches && menu.hasClass('active')) || window.matchMedia("(min-width: 1025px)").matches) {
            menu.css('margin-top', '0px');
        } else {
            menu.css('margin-top', '-' + height + 'px');
        }
    }

};